module.exports = __webpack_public_path__ + "static/media/group.dd17aed3.svg";